import { render } from "./HomeFooter.vue?vue&type=template&id=c6448bca&scoped=true&ts=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"

import "./HomeFooter.vue?vue&type=style&index=0&id=c6448bca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6448bca"]])

export default __exports__